module.exports = __webpack_public_path__ + "img/border-1.8f6d4e74.svg";